import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import DealField, { propTypes } from 'bundles/apex/deals/form/fields/field';
import ManagedFormGroup from 'components/form/managed_input/form_group';

export function LeaseType({ changeDeal, deal, invalid, label, options, required }) {
  return (
    <ManagedFormGroup
      hasError={invalid}
      includeBlank
      label={label}
      name="leaseTypeId"
      required={required}
      type="select"
      value={deal.leaseTypeId}
      onValueChange={leaseTypeId => changeDeal({ leaseTypeId: parseInt(leaseTypeId) })}
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </ManagedFormGroup>
  );
}

LeaseType.propTypes = {
  ...propTypes,
  deal: PropTypes.shape({
    leaseTypeId: PropTypes.number,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  })).isRequired,
};

const mapStateToProps = state => ({
  options: state.options.leaseType,
});

export default connect(mapStateToProps)(DealField(LeaseType, 'leaseType'));
